(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nhp-filter-buttons"] && !Shopify.designMode) return;
  try {
    
$(document).on('click','.nhp-filter-button',function(){
    console.log('tin',arr)
    let page = arr2.pop();
     let h_url = location.href;
    let _url;
     if(h_url.indexOf('?filter') != -1 ){
       _url = h_url+"&page=" + page;
        console.log(_url);
     }
    else{
      _url = "{{shop.url}}/collections/{{collection.handle}}?page=" + page;
    console.log(_url);
    }
}
)



  } catch(e) { console.error(e); }
})();
})();
